import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import Form from "./EditCompanyForm";

export default function EditCompanyFields({ open, close, record }) {
  const initialValues = {
    company_id: record.getIn(["company", "id"]),
    contact_id: record.getIn(["contact", "id"]),
    ...record.toJS()
  };
  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Repair Order Details</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        record={record}
        enableReinitialize
      />
    </Modal>
  );
}

EditCompanyFields.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  record: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Edit/EditCompanyFields.jsx